import { render } from "./Query.vue?vue&type=template&id=9971fbd6"
import script from "./Query.vue?vue&type=script&lang=js"
export * from "./Query.vue?vue&type=script&lang=js"
script.render = render

export default script